import { useTranslation } from 'react-i18next';
import { useModal } from '../../contexts';
import Modal from '../Modal';

function OnboardingConfirmRegenerateModal({ onConfirm }: { onConfirm: () => void }) {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <Modal
      size="sm"
      title={t('Replace your generated document?')}
      primaryButtonProps={{
        text: t('Replace'),
        onClick: () => {
          closeModal();
          onConfirm();
        },
      }}
      secondaryButtonProps={{
        text: t('Cancel'),
        onClick: closeModal,
      }}
    >
      <p className="font-semibold text-sm text-gray-500">
        {t("You've changed your selection. Continuing will discard the document already being generated and start a new one.")}
      </p>
    </Modal>
  );
}

export default OnboardingConfirmRegenerateModal;
